import { useCallback } from 'react';
import { getDataType } from 'reporting-data/report/configReportGetters';
import UnifiedEventDropdown from 'report-customization-components/components/unified-event-dropdown/UnifiedEventDropdown';
import { getIsReportValidForUnifiedEventDropdown } from 'report-customization-components/components/unified-event-dropdown/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const EventSearchSelector = ({
  report,
  updateContext
}) => {
  const handleChange = useCallback(newReport => updateContext({
    event: getDataType(newReport)
  }, report), [updateContext, report]);
  return /*#__PURE__*/_jsx(UnifiedEventDropdown, {
    report: report,
    onChange: handleChange
  });
};
EventSearchSelector.isUsableForReport = ({
  report,
  subAppKey
}) => {
  return getIsReportValidForUnifiedEventDropdown({
    report
  }) && Boolean(subAppKey);
};
export default EventSearchSelector;